import React from 'react';

interface ArticletypeProps {
  type: string;
}

const Themes: React.FC<ArticletypeProps> = (props) => {
  const {
    type,
  } = props;

  return (
    <div className="ArticleMetadata__articletype">
      <span>{type}</span>
    </div>
  );
};

export default Themes;
